export const cn = [
  { _id: 'alencia', name: '\u827e\u83b2\u897f\u96c5', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  {
    _id: 'ambitious-tywin',
    name: '\u91ce\u5fc3\u5206\u5b50\u6cf0\u6e29',
    rarity: 5,
    role: 'knight',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'apocalypse-ravi',
    name: '\u672b\u65e5\u841d\u83f2',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'aramintha', name: '\u96c5\u62c9\u654f\u5854', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'arbiter-vildred',
    name: '\u6267\u884c\u5b98\u7ef4\u5fb7\u745e',
    rarity: 5,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'archdemons-shadow',
    name: '\u9b54\u795e\u7684\u6697\u5f71',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  {
    _id: 'baal-sezan',
    name: '\u5df4\u5c14\uff06\u585e\u5c1a',
    rarity: 5,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'twins',
  },
  { _id: 'baiken', name: '\u6885\u55a7', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'basar', name: '\u5df4\u8428\u5c14', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'waterbearer' },
  { _id: 'bellona', name: '\u7ef4\u5c14\u841d\u5a1c', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'blood-moon-haste',
    name: '\u8d64\u6708\u8d35\u65cf\u6d77\u65af\u7279',
    rarity: 5,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'bomb-model-kanna',
    name: '\u66b4\u51fb\u578b\u5361\u519c',
    rarity: 5,
    role: 'ranger',
    attribute: 'fire',
    zodiac: 'twins',
  },
  {
    _id: 'briar-witch-iseria',
    name: '\u7070\u5149\u68ee\u6797\u7684\u4f0a\u8d5b\u4e3d\u4e9a',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'cecilia', name: '\u8d5b\u897f\u8389\u4e9a', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'celine', name: '\u745f\u7433', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'cerise', name: '\u8d5b\u745e\u4e1d', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'cermia', name: '\u6d01\u82e5\u7c73\u4e9a', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'lion' },
  { _id: 'charles', name: '\u67e5\u5c14\u65af', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'charlotte', name: '\u590f\u7eff\u8482', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'lion' },
  { _id: 'chloe', name: '\u514b\u841d\u7231', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'archer' },
  { _id: 'choux', name: '\u5c0f\u6ce1\u8299', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'goat' },
  {
    _id: 'dark-corvus',
    name: '\u9ed1\u6697\u7684\u79d1\u5c14\u5e03\u601d',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'goat',
  },
  {
    _id: 'desert-jewel-basar',
    name: '\u6c99\u6f20\u5b9d\u77f3\u5df4\u8428\u5c14',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'designer-lilibet',
    name: '\u8bbe\u8ba1\u5e08\u8389\u8389\u8d1d',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'destina', name: '\u6234\u4e1d\u8482\u5a1c', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'crab' },
  { _id: 'diene', name: '\u8fea\u57c3\u59ae', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'dizzy', name: '\u8482\u59ec', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'eda', name: '\u827e\u59b2', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'elena', name: '\u827e\u857e\u5a1c', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'elphelt', name: '\u7231\u5c14\u83f2\u7279', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'goat' },
  {
    _id: 'ervalen',
    name: '\u827e\u5c14\u5df4\u4f26',
    rarity: 5,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'scorpion',
  },
  {
    _id: 'fairytale-tenebria',
    name: '\u7ae5\u8bdd\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'ice',
    zodiac: 'bull',
  },
  {
    _id: 'faithless-lidica',
    name: '\u65e0\u795e\u8bba\u8005\u4e3d\u8fea\u5361',
    rarity: 5,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'fallen-cecilia',
    name: '\u5815\u843d\u7684\u8d5b\u897f\u8389\u4e9a',
    rarity: 5,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'flan', name: '\u8299\u5170', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'goat' },
  { _id: 'haste', name: '\u6d77\u65af\u7279', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'holiday-yufine',
    name: '\u5ea6\u5047\u98ce\u4f18\u82ac\u59ae',
    rarity: 5,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'scales',
  },
  { _id: 'iseria', name: '\u4f0a\u8d5b\u4e3d\u4e9a', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'judge-kise',
    name: '\u5ba1\u5224\u8005\u7eee\u4e16',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'maiden',
  },
  { _id: 'kawerik', name: '\u5361\u5a01\u5229', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'kayron', name: '\u51ef\u9686', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'ram' },
  { _id: 'ken', name: '\u80af\u6069', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'kise', name: '\u7eee\u4e16', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'krau', name: '\u514b\u52b3\u4e4c', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'fish' },
  { _id: 'landy', name: '\u5170\u8482', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'last-rider-krau',
    name: '\u6700\u540e\u7684\u9a91\u58eb\u514b\u52b3\u4e4c',
    rarity: 5,
    role: 'knight',
    attribute: 'light',
    zodiac: 'fish',
  },
  { _id: 'lidica', name: '\u4e3d\u8fea\u5361', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'lilias', name: '\u8389\u8389\u4e9a\u65af', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'lilibet', name: '\u8389\u8389\u8d1d', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  {
    _id: 'little-queen-charlotte',
    name: '\u5e74\u8f7b\u7684\u5973\u738b\u590f\u7eff\u8482',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'ludwig', name: '\u9c81\u7279\u6bd4', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'lion' },
  { _id: 'luluca', name: '\u7490\u7490\u5361', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'luna', name: '\u9732\u5a1c', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  {
    _id: 'maid-chloe',
    name: '\u4ec6\u4eba\u514b\u841d\u7231',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'maiden',
  },
  {
    _id: 'martial-artist-ken',
    name: '\u6b66\u6597\u5bb6\u80af\u6069',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'mediator-kawerik',
    name: '\u534f\u8c03\u8005\u5361\u5a01\u5229',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'goat',
  },
  { _id: 'melissa', name: '\u6885\u4e3d\u838e', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'lion' },
  { _id: 'mort', name: '\u9b54\u52d2', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'mui', name: '\u7f2a\u4f0a', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'operator-sigret',
    name: '\u64cd\u4f5c\u5458\u8d5b\u73c2\u5170\u7279',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'scales',
  },
  { _id: 'pavel', name: '\u5e15\u8d1d\u5c14', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  { _id: 'politis', name: '\u4f5b\u91cc\u8482\u4e1d', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'ravi', name: '\u841d\u83f2', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'ray', name: '\u96f7\u4f0a', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'bull' },
  {
    _id: 'remnant-violet',
    name: '\u6b8b\u5f71\u7684\u83f2\u5965\u96f7\u6258',
    rarity: 5,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'lion',
  },
  { _id: 'roana', name: '\u7f57\u5b89\u7eb3', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'fish' },
  {
    _id: 'ruele-of-light',
    name: '\u5149\u4e4b\u745e\u513f',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'fish',
  },
  {
    _id: 'sage-baal-sezan',
    name: '\u8d24\u8005\u5df4\u5c14\uff06\u585e\u5c1a',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'seaside-bellona',
    name: '\u6d77\u8fb9\u7684\u7ef4\u5c14\u841d\u5a1c',
    rarity: 5,
    role: 'ranger',
    attribute: 'ice',
    zodiac: 'twins',
  },
  { _id: 'senya', name: '\u8d5b\u5a1c', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'bull' },
  { _id: 'sez', name: '\u8d5b\u5179', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'sigret', name: '\u8d5b\u73c2\u5170\u7279', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'bull' },
  {
    _id: 'silver-blade-aramintha',
    name: '\u767d\u94f6\u5200\u5203\u7684\u96c5\u62c9\u654f\u5854',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'twins',
  },
  { _id: 'sol', name: '\u7d22\u5c14', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'archer' },
  {
    _id: 'solitaria-of-the-snow',
    name: '\u96ea\u56fd\u7684\u82cf\u8389\u5854\u59ae\u4e9a',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'specimen-sez',
    name: '\u5b9e\u9a8c\u4f53\u8d5b\u5179',
    rarity: 5,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  {
    _id: 'specter-tenebria',
    name: '\u5e7b\u5f71\u7684\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'tamarinne',
    name: '\u5854\u739b\u6797\u5c14',
    rarity: 5,
    role: 'manauser',
    attribute: 'fire',
    zodiac: 'archer',
  },
  {
    _id: 'tenebria',
    name: '\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'crab',
  },
  {
    _id: 'top-model-luluca',
    name: '\u6700\u5f3a\u6a21\u7279\u513f\u7490\u7490\u5361',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'tywin', name: '\u6cf0\u6e29', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'ram' },
  { _id: 'vildred', name: '\u7ef4\u5fb7\u745e', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'violet',
    name: '\u83f2\u5965\u96f7\u6258',
    rarity: 5,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'scorpion',
  },
  { _id: 'vivian', name: '\u8587\u8587\u5b89', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  { _id: 'yufine', name: '\u4f18\u82ac\u59ae', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'bull' },
  { _id: 'yuna', name: '\u5c24\u5a1c', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  { _id: 'zeno', name: '\u6770\u8bfa', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'achates', name: '\u96c5\u5361\u6cf0\u4e1d', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'twins' },
  { _id: 'angelica', name: '\u5b89\u6d01\u8389\u5361', rarity: 4, role: 'manauser', attribute: 'ice', zodiac: 'crab' },
  { _id: 'armin', name: '\u4e9a\u654f', rarity: 4, role: 'knight', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'assassin-cartuja',
    name: '\u6740\u624b\u5361\u5c14\u56fe\u54c8',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'assassin-cidd',
    name: '\u6740\u624b\u5e2d\u5fb7',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  {
    _id: 'assassin-coli',
    name: '\u6740\u624b\u53ef\u4e3d',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'auxiliary-lots',
    name: '\u8f85\u52a9\u578b\u62c9\u5179',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'benevolent-romann',
    name: '\u4ec1\u6148\u7684\u6d1b\u66fc',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'blaze-dingo',
    name: '\u70c8\u706b\u6c40\u679c',
    rarity: 4,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'blood-blade-karin',
    name: '\u8840\u5251\u5361\u7433',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  { _id: 'cartuja', name: '\u5361\u5c14\u56fe\u54c8', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  {
    _id: 'celestial-mercedes',
    name: '\u5916\u592a\u7a7a\u7684\u73ab\u52d2\u8d5b\u5fb7\u4e1d',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'challenger-dominiel',
    name: '\u6311\u6218\u8005\u591a\u7c73\u59ae\u5c14',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'champion-zerato',
    name: '\u7ec8\u7ed3\u8005\u6770\u62c9\u56fe',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'ram',
  },
  { _id: 'cidd', name: '\u5e2d\u5fb7', rarity: 4, role: 'assassin', attribute: 'wind', zodiac: 'ram' },
  { _id: 'clarissa', name: '\u514b\u83b1\u8389\u838e', rarity: 4, role: 'warrior', attribute: 'ice', zodiac: 'lion' },
  { _id: 'coli', name: '\u53ef\u4e3d', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'corvus', name: '\u79d1\u5c14\u5e03\u601d', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'crab' },
  {
    _id: 'crescent-moon-rin',
    name: '\u65b0\u6708\u821e\u59ec\u94c3\u513f',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'crimson-armin',
    name: '\u7ea2\u7130\u4e9a\u654f',
    rarity: 4,
    role: 'knight',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'crozet', name: '\u514b\u7f57\u6cfd', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'crab' },
  { _id: 'dingo', name: '\u6c40\u679c', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'dominiel', name: '\u591a\u7c73\u59ae\u5c14', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  {
    _id: 'fighter-maya',
    name: '\u6218\u6597\u578b\u739b\u96c5',
    rarity: 4,
    role: 'knight',
    attribute: 'light',
    zodiac: 'scales',
  },
  {
    _id: 'free-spirit-tieria',
    name: '\u6c38\u6052\u4e0d\u53d8\u7684\u9edb\u8389\u4e9a',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'maiden',
  },
  { _id: 'furious', name: '\u5c24\u8d1d\u4e4c\u65af', rarity: 4, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'general-purrgis',
    name: '\u5927\u5c06\u6cd5\u6d4e\u65af',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'great-chief-khawana',
    name: '\u5927\u65cf\u957f\u5361\u74e6\u5a1c',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'guider-aither',
    name: '\u6c42\u9053\u8005\u57c3\u5fb7\u52d2',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'crab',
  },
  { _id: 'karin', name: '\u5361\u7433', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'khawana', name: '\u5361\u74e6\u5a1c', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  { _id: 'khawazu', name: '\u5361\u74e6\u6731', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'scorpion' },
  {
    _id: 'kitty-clarissa',
    name: '\u732b\u54aa\u514b\u83b1\u8389\u838e',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'maiden',
  },
  { _id: 'kizuna-ai', name: '\u7eca\u7231', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'crab' },
  { _id: 'leo', name: '\u96f7\u6b27', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'lots', name: '\u62c9\u5179', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'twins' },
  { _id: 'maya', name: '\u739b\u96c5', rarity: 4, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  {
    _id: 'mercedes',
    name: '\u73ab\u52d2\u8d5b\u5fb7\u4e1d',
    rarity: 4,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'scorpion',
  },
  { _id: 'purrgis', name: '\u6cd5\u6d4e\u65af', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'rin', name: '\u94c3\u513f', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'roaming-warrior-leo',
    name: '\u6d41\u6d6a\u52c7\u58eb\u96f7\u6b27',
    rarity: 4,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'romann', name: '\u6d1b\u66fc', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'twins' },
  { _id: 'rose', name: '\u841d\u5b63', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'scales' },
  { _id: 'schuri', name: '\u4fee\u91cc', rarity: 4, role: 'ranger', attribute: 'fire', zodiac: 'lion' },
  { _id: 'serila', name: '\u585e\u4e3d\u62c9', rarity: 4, role: 'mage', attribute: 'fire', zodiac: 'waterbearer' },
  {
    _id: 'shadow-rose',
    name: '\u6697\u5f71\u841d\u5b63',
    rarity: 4,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'shooting-star-achates',
    name: '\u6d41\u661f\u96c5\u5361\u6cf0\u4e1d',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'silk', name: '\u5e2d\u53ef', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'sinful-angelica',
    name: '\u7f6a\u623e\u7684\u5b89\u6d01\u8389\u5361',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'bull',
  },
  { _id: 'surin', name: '\u82cf\u7433', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'tempest-surin',
    name: '\u98ce\u4e91\u82cf\u7433',
    rarity: 4,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'troublemaker-crozet',
    name: '\u4e0d\u6cd5\u4e4b\u5f92\u514b\u7f57\u6cfd',
    rarity: 4,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'wanderer-silk',
    name: '\u6d41\u6d6a\u8005\u5e2d\u53ef',
    rarity: 4,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'goat',
  },
  {
    _id: 'watcher-schuri',
    name: '\u6ce8\u89c6\u8005\u4fee\u91cc',
    rarity: 4,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  { _id: 'zerato', name: '\u6770\u62c9\u56fe', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'adlay', name: '\u4e9a\u8fea\u8d56', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  {
    _id: 'adventurer-ras',
    name: '\u5192\u9669\u5bb6\u62c9\u65af',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'scales',
  },
  { _id: 'ainos', name: '\u827e\u8bfa\u65af', rarity: 3, role: 'manauser', attribute: 'dark', zodiac: 'archer' },
  { _id: 'ains', name: '\u827e\u56e0\u5179', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  { _id: 'aither', name: '\u57c3\u5fb7\u52d2', rarity: 3, role: 'manauser', attribute: 'ice', zodiac: 'scales' },
  { _id: 'alexa', name: '\u96c5\u8389\u838e', rarity: 3, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'allrounder-wanda',
    name: '\u7591\u96be\u6742\u75c7\u4e13\u5bb6\u6c6a\u8fbe',
    rarity: 3,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'angelic-montmorancy',
    name: '\u5b88\u62a4\u5929\u4f7f\u8499\u8309\u6717\u897f',
    rarity: 3,
    role: 'manauser',
    attribute: 'ice',
    zodiac: 'fish',
  },
  { _id: 'arowell', name: '\u96c5\u6d1b\u8587', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'scales' },
  {
    _id: 'azalea',
    name: '\u4e9a\u6d01\u7406\u4e9a',
    rarity: 3,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'scorpion',
  },
  { _id: 'bask', name: '\u5df4\u601d\u514b', rarity: 3, role: 'knight', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'batisse', name: '\u5df4\u6258\u65af', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'bull' },
  {
    _id: 'butcher-corps-inquisitor',
    name: '\u5c60\u6740\u90e8\u961f\u5458',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  {
    _id: 'captain-rikoris',
    name: '\u5148\u950b\u961f\u957f\u91cc\u79d1\u9ece\u53f8',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  {
    _id: 'carmainerose',
    name: '\u5361\u9ea6\u841d\u5179',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
  { _id: 'carrot', name: '\u5361\u841d', rarity: 3, role: 'mage', attribute: 'fire', zodiac: 'archer' },
  { _id: 'celeste', name: '\u8d5b\u96f7\u65af\u7279', rarity: 3, role: 'ranger', attribute: 'light', zodiac: 'archer' },
  {
    _id: 'chaos-inquisitor',
    name: '\u6df7\u6c8c\u6559\u5c60\u6740\u8ffd\u51fb\u8005',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  {
    _id: 'chaos-sect-axe',
    name: '\u6df7\u6c8c\u6559\u5de8\u65a7\u5927\u5c06\u519b',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'church-of-ilryos-axe',
    name: '\u4f0a\u5229\u6b27\u65af\u6559\u65a7\u5175',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'commander-lorina',
    name: '\u6307\u6325\u5b98\u841d\u91cc\u5a1c',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'doll-maker-pearlhorizon',
    name: '\u5236\u5076\u5e08\u6ce2\u841d\u83b1\u73cd',
    rarity: 3,
    role: 'mage',
    attribute: 'wind',
    zodiac: 'bull',
  },
  { _id: 'doris', name: '\u6735\u8389\u601d', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'crab' },
  { _id: 'eaton', name: '\u4f0a\u987f', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'crab' },
  { _id: 'elson', name: '\u827e\u5c14\u68ee', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  { _id: 'enott', name: '\u827e\u8bfa\u7279', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scorpion' },
  {
    _id: 'falconer-kluri',
    name: '\u9e70\u730e\u4eba\u53ef\u9732\u8389',
    rarity: 3,
    role: 'knight',
    attribute: 'wind',
    zodiac: 'ram',
  },
  { _id: 'glenn', name: '\u683c\u4f26', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'scales' },
  { _id: 'gloomyrain', name: '\u683c\u9c81\u7f8e\u5170', rarity: 3, role: 'mage', attribute: 'light', zodiac: 'crab' },
  { _id: 'godmother', name: '\u6559\u6bcd', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'twins' },
  { _id: 'gunther', name: '\u5764\u7279', rarity: 3, role: 'warrior', attribute: 'light', zodiac: 'scales' },
  { _id: 'hataan', name: '\u54c8\u5766', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'lion' },
  { _id: 'hazel', name: '\u6d77\u5179', rarity: 3, role: 'manauser', attribute: 'fire', zodiac: 'waterbearer' },
  { _id: 'helga', name: '\u8d6b\u5c14\u5609', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  { _id: 'hurado', name: '\u4fee\u62c9\u675c', rarity: 3, role: 'mage', attribute: 'dark', zodiac: 'fish' },
  { _id: 'ian', name: '\u4f0a\u5b89', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'maiden' },
  { _id: 'jecht', name: '\u6770\u514b\u6258', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'archer' },
  { _id: 'jena', name: '\u6377\u5a1c', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'judith', name: '\u8331\u8fea\u4e1d', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  {
    _id: 'kikirat-v2',
    name: '\u5947\u5947\u62c9\u7279V.2',
    rarity: 3,
    role: 'knight',
    attribute: 'light',
    zodiac: 'goat',
  },
  { _id: 'kiris', name: '\u5947\u4e3d\u4e1d', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'kluri', name: '\u53ef\u9732\u8389', rarity: 3, role: 'knight', attribute: 'wind', zodiac: 'ram' },
  { _id: 'lena', name: '\u96f7\u5a1c', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  { _id: 'lorina', name: '\u841d\u91cc\u5a1c', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'lion' },
  { _id: 'lucy', name: '\u9732\u897f', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'magic-scholar-doris',
    name: '\u9b54\u6cd5\u5b66\u8005\u6735\u8389\u601d',
    rarity: 3,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'mascot-hazel',
    name: '\u5409\u7965\u7269\u6d77\u5179',
    rarity: 3,
    role: 'manauser',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
  {
    _id: 'mercenary-helga',
    name: '\u81ea\u7531\u81ea\u5728\u7684\u4f63\u5175\u8d6b\u5c14\u5609',
    rarity: 3,
    role: 'warrior',
    attribute: 'wind',
    zodiac: 'archer',
  },
  { _id: 'mirsa', name: '\u7c73\u52d2\u838e', rarity: 3, role: 'assassin', attribute: 'light', zodiac: 'fish' },
  { _id: 'mistychain', name: '\u7f8e\u4e1d\u7f07\u5f69', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'montmorancy',
    name: '\u8499\u8309\u6717\u897f',
    rarity: 3,
    role: 'manauser',
    attribute: 'ice',
    zodiac: 'fish',
  },
  { _id: 'mucacha', name: '\u7a46\u5361\u5bdf', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  {
    _id: 'muse-rima',
    name: '\u7f2a\u65af\u9ece\u739b',
    rarity: 3,
    role: 'ranger',
    attribute: 'ice',
    zodiac: 'waterbearer',
  },
  { _id: 'nemunas', name: '\u5c3c\u59c6\u62c9\u65af', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'scales' },
  { _id: 'otillie', name: '\u5965\u7f07\u8389\u5c14', rarity: 3, role: 'mage', attribute: 'dark', zodiac: 'bull' },
  { _id: 'pearlhorizon', name: '\u6ce2\u841d\u83b1\u73cd', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'bull' },
  { _id: 'pyllis', name: '\u8d39\u8389\u4e1d', rarity: 3, role: 'knight', attribute: 'dark', zodiac: 'crab' },
  { _id: 'ras', name: '\u62c9\u65af', rarity: 3, role: 'knight', attribute: 'fire', zodiac: 'scales' },
  {
    _id: 'requiemroar',
    name: '\u96f7\u594e\u59c6\u6d1b',
    rarity: 3,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'archer',
  },
  {
    _id: 'researcher-carrot',
    name: '\u7814\u7a76\u8005\u5361\u841d',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'archer',
  },
  {
    _id: 'righteous-thief-roozid',
    name: '\u4e49\u8d3c\u9c81\u5179\u5fb7',
    rarity: 3,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'twins',
  },
  {
    _id: 'rikoris',
    name: '\u91cc\u79d1\u9ece\u53f8',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'rima', name: '\u9ece\u739b', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'roozid', name: '\u9c81\u5179\u5fb7', rarity: 3, role: 'assassin', attribute: 'wind', zodiac: 'twins' },
  { _id: 'sonia', name: '\u82cf\u5c3c\u5a05', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  { _id: 'sven', name: '\u53f2\u5bbe', rarity: 3, role: 'assassin', attribute: 'dark', zodiac: 'scorpion' },
  {
    _id: 'taranor-guard',
    name: '\u5854\u62c9\u8bfa\u5c14\u7981\u536b\u961f\u5458',
    rarity: 3,
    role: 'warrior',
    attribute: 'ice',
    zodiac: 'scales',
  },
  {
    _id: 'taranor-royal-guard',
    name: '\u5854\u62c9\u8bfa\u5c14\u738b\u5bab\u58eb\u5175',
    rarity: 3,
    role: 'knight',
    attribute: 'ice',
    zodiac: 'scorpion',
  },
  { _id: 'tieria', name: '\u9edb\u8389\u4e9a', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'ram' },
  { _id: 'wanda', name: '\u6c6a\u8fbe', rarity: 3, role: 'ranger', attribute: 'dark', zodiac: 'twins' },
  {
    _id: 'zealot-carmainerose',
    name: '\u4f20\u9053\u8005\u5361\u9ea6\u841d\u5179',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
];
